import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Editable,
  EditablePreview,
  EditableTextarea,
  Grid,
  Text,
  useEditableContext,
  useEditableControls,
} from '@chakra-ui/react'
import { useState } from 'react'

export interface NoteProps {
  date?: string | undefined
  text?: string | undefined
  onChange?: (text: string) => void
}

const EditableControls = () => {
  const {
    isEditing,
    getSubmitButtonProps,
    getCancelButtonProps,
    getEditButtonProps,
  } = useEditableControls()
  const { value } = useEditableContext()
  const isEmpty = !value || value === ''

  if (isEditing) {
    return (
      <ButtonGroup>
        <Button variant="ghost" {...getCancelButtonProps()}>
          Zrušit
        </Button>
        <Button colorScheme="green" {...getSubmitButtonProps()}>
          Uložit
        </Button>
      </ButtonGroup>
    )
  }

  if (!isEditing && isEmpty) {
    return (
      <Button colorScheme="gray" {...getEditButtonProps()}>
        Napsat poznámku
      </Button>
    )
  }

  return null
}

export const Note = ({ date, text, onChange }: NoteProps) => {
  const [noteText, setNoteText] = useState<string | undefined>(text)

  const handleChange = (text: string) => {
    setNoteText(text)
  }

  const handleSubmit = (text: string) => {
    setNoteText(text)
    onChange?.(text)
  }

  return (
    <Card
      sx={{
        mb: 8,
        borderTopRadius: {
          base: 'md',
          md: 0,
        },
        borderBottomRadius: 'md',
      }}
    >
      <CardBody sx={{ px: { base: 8, md: 8 }, py: { base: 4, md: 4 } }}>
        <Grid
          sx={{
            gridTemplateColumns: 'max-content auto',
            alignItems: noteText ? 'start' : 'center',
            gap: 8,
          }}
        >
          <Grid sx={{ alignSelf: 'start', pt: 1 }}>
            <Text sx={{ fontSize: 'md', fontWeight: 'bold' }}>Poznámka</Text>
            <Text
              sx={{ color: 'gray.600', fontSize: 'sm', fontWeight: 'medium' }}
            >
              {date}
            </Text>
          </Grid>

          <Grid sx={{ justifyItems: 'start' }}>
            <Editable
              value={noteText}
              onChange={handleChange}
              onSubmit={handleSubmit}
              sx={{
                w: '100%',
                h: '100%',
                display: 'grid',
                alignSelf: 'center',
                justifyItems: 'start',
                gap: 2,
              }}
            >
              {noteText && (
                <EditablePreview
                  sx={{
                    fontSize: {
                      base: 'lg',
                      md: 'sm',
                    },
                  }}
                />
              )}

              <EditableTextarea
                sx={{
                  fontSize: {
                    base: 'lg',
                    md: 'sm',
                  },
                }}
              />

              <Grid sx={{ alignSelf: 'center', justifySelf: 'end' }}>
                <EditableControls />
              </Grid>
            </Editable>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}
